import React from 'react'
import CloudRestroUsers from '../../../../services/DatabaseService/CloudRestroUsers';
import { Button, Form, FormFeedback, Input, Label, Modal, ModalBody, ModalHeader } from 'reactstrap';
import { useFormik } from 'formik';
import * as Yup from "yup";
import toast from 'react-hot-toast';


const UpdateExpiry = ({orgcode,modalOpen,toggleModal}) => {
    console.log(orgcode)
    const validationSchema = Yup.object({
        amount: Yup.number().typeError("Amount must be a number").required("Amount is Required").positive("Amount must be greater than 0"),

        newDate: Yup.date()
            .typeError("Please select a valid date")
            .required("Date is required"),
    });

    const formik = useFormik({
        initialValues: {
            orgCode:"",
            amount:"",
            newDate:""
        },
        validationSchema,
        onSubmit:async (values) => {
            try{
                const payload = {
                    orgCode:orgcode,
                    amount: values.amount,
                    newDate: values.newDate
                };
                await CloudRestroUsers.updateExpirydate(payload);
                
                toast.success("Expiry Date Updated Successfully");
                toggleModal();


            }catch(error){
                console.log(error.message);
                toast.error("Error updating the expiry date")
            }
        }
    });
    return (
        <Modal
            isOpen={modalOpen}
            toggle={toggleModal}
            // centered
            

            contentClassName="p-3 rounded shadow-lg border-0"    
        >
            <ModalHeader
                toggle={toggleModal}
                className="bg-gradient-primary text-white rounded-top shadow-sm"
                style={{ borderBottom: "2px solid #cecedbff" }}
            >
                Update Expiry Date

            </ModalHeader>
            <ModalBody className='d-flex flex-column gap-3' style={{ maxHeight: '70vh', overflowY: 'auto' }}>
                <Form onSubmit={formik.handleSubmit}>
                <div>
                <Label className = "fw-bold">Amount<span className='text-danger'>*</span></Label>
                <Input
                    name="amount"
                    type="number"
                    placeholder="Enter Amount"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    invalid={!!formik.touched.amount && formik.errors.amount}
                    className="shadow-sm rounded border border-secondary"
                    style={{transition:"0.3s", padding: "0.5rem"}}
                />
                {formik.touched.amount && formik.errors.amount && (
              <FormFeedback className="text-danger">{formik.errors.amount}</FormFeedback>
            )}
            </div>

            <div>
            <Label className="fw-bold">New Expiry Date <span className="text-danger">*</span></Label>
            <Input
              name="newDate"
              type="date"
              value={formik.values.newDate}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              invalid={!!(formik.touched.newDate && formik.errors.newDate)}
              className="shadow-sm rounded border border-secondary"
              style={{ padding: "0.5rem" }}
            />
            {formik.touched.newDate && formik.errors.newDate && (
              <FormFeedback className="text-danger">{formik.errors.newDate}</FormFeedback>
            )}
          </div>

          {/* Submit Button */}
          <div className="d-flex justify-content-end mt-2">
            <Button
              type="submit"
              className="px-4 py-2 rounded shadow-sm"
              style={{
                backgroundColor: "#0d6efd",
                borderColor: "#0d6efd",
                transition: "0.3s",
              }}
              onMouseOver={(e) => (e.currentTarget.style.backgroundColor = "#0b5ed7")}
              onMouseOut={(e) => (e.currentTarget.style.backgroundColor = "#0d6efd")}
            >
              Update
            </Button>
          </div>
          </Form>
            </ModalBody>
        </Modal>
        
    )
}

export default UpdateExpiry
